"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GROUP_OPEN = exports.CANCELED_DISABLED = exports.RETURNED = exports.PROCESSING_CREDIT = exports.PROCESSING_DEBIT = exports.QUEUED_BY_SYNAPSE = exports.MEDIATION_SETTLED_SELLER = exports.MEDIATION_SETTLED_BUYER = exports.MATCHED = exports.IN_PROGRESS = exports.PENDING_TRANSFER = exports.FRAUD_APPROVED = exports.FRAUD_REJECTED = exports.FRAUD_REVIEW = exports.PENDING = exports.MERGED = exports.MEDIATION_SETTLED_TAKER = exports.MEDIATION_SETTLED_MAKER = exports.MEDIATION = exports.CANCELED = exports.CANCEL_REQUESTED = exports.COMPLETED = exports.CONFIRMED = exports.ACCEPTED = exports.CREATED = exports.FAILED = exports.ERROR = exports.UNEXISTING = exports.UPDATE_PENDING = exports.CREATION_PENDING = void 0;
exports.CREATION_PENDING = 'CREATION_PENDING';
exports.UPDATE_PENDING = 'UPDATE_PENDING';
exports.UNEXISTING = 'UNEXISTING';
exports.ERROR = 'ERROR';
exports.FAILED = 'FAILED';
exports.CREATED = 'CREATED';
exports.ACCEPTED = 'ACCEPTED';
exports.CONFIRMED = 'CONFIRMED';
exports.COMPLETED = 'COMPLETED';
exports.CANCEL_REQUESTED = 'CANCEL_REQUESTED';
exports.CANCELED = 'CANCELED';
exports.MEDIATION = 'MEDIATION';
exports.MEDIATION_SETTLED_MAKER = 'MEDIATION_SETTLED_MAKER';
exports.MEDIATION_SETTLED_TAKER = 'MEDIATION_SETTLED_TAKER';
exports.MERGED = 'MERGED'; // for MATCHED PEER_TO_PEER operations only
exports.PENDING = 'PENDING';
exports.FRAUD_REVIEW = 'FRAUD_REVIEW';
exports.FRAUD_REJECTED = 'FRAUD_REJECTED';
exports.FRAUD_APPROVED = 'FRAUD_APPROVED';
exports.PENDING_TRANSFER = 'PENDING_TRANSFER';
exports.IN_PROGRESS = 'IN_PROGRESS'; // for stellar usdc direct withdraws
/*
 * MERGED_PEER_TO_PEER exclusive status
 */
exports.MATCHED = 'MATCHED';
exports.MEDIATION_SETTLED_BUYER = 'MEDIATION_SETTLED_BUYER';
exports.MEDIATION_SETTLED_SELLER = 'MEDIATION_SETTLED_SELLER';
/*
 * Synapse exclusive status
 */
exports.QUEUED_BY_SYNAPSE = 'QUEUED_BY_SYNAPSE';
exports.PROCESSING_DEBIT = 'PROCESSING_DEBIT';
exports.PROCESSING_CREDIT = 'PROCESSING_CREDIT';
exports.RETURNED = 'RETURNED';
// meta-status used for hiding re-created operations from the activity feed
exports.CANCELED_DISABLED = 'CANCELED_DISABLED';
exports.GROUP_OPEN = [
    exports.CREATED,
    exports.ACCEPTED,
    exports.FRAUD_APPROVED,
    exports.FRAUD_REVIEW,
    exports.CONFIRMED,
    exports.CANCEL_REQUESTED,
    exports.MEDIATION,
    exports.PENDING,
    exports.UPDATE_PENDING,
];
